import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Typography from '@mui/material/Typography';
import TableCell from 'components/TableCell';
import DashboardFlightsTableRow from 'components/DashboardFlightsTableRow';

import { DashboardFlightsCardTable_flightsInfo$key } from '__generated__/DashboardFlightsCardTable_flightsInfo.graphql';

type Props = {
  flightsInfo: DashboardFlightsCardTable_flightsInfo$key;
};

const DashboardFlightsCardTable: FC<Props> = props => {
  const { failedFlights } = useFragment(
    graphql`
      fragment DashboardFlightsCardTable_flightsInfo on DashboardFlightsInfo {
        failedFlights {
          id
          ...DashboardFlightsTableRow_flight
        }
      }
    `,
    props.flightsInfo
  );

  return (
    <TableContainer sx={{ mt: 2 }}>
      <Typography variant="caption">
        Ilgiausiai neatnaujinti skrydžiai
      </Typography>

      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Skrydis</TableCell>
            <TableCell center>Atnaujinta prieš</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {failedFlights.map(flight => (
            <DashboardFlightsTableRow key={flight.id} flight={flight} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DashboardFlightsCardTable;
